import styled from '@emotion/styled';

export const StyledUserMessage = styled.div`
  position: relative;
  padding: 6px 10px;
  border-radius: 5px;
  border: 2px solid transparent;
  background: linear-gradient(90.47deg, #daebff 0.01%, #e0f7ff 100.01%);
  background-clip: padding-box;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    margin: -2px;
    border-radius: inherit;
    background: linear-gradient(90.47deg, #0172ea 0.01%, #01c4fe 100.01%);
  }
`;

export const StyledBotMessage = styled.span`
  position: relative;
  padding: 6px 10px;
  border-radius: 5px;
  background: ${({ theme }) => theme.colors.lightGray2};
`;

export const StyledConversationHistoryDetails = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: ${({ theme }) => theme.boxShadows.box};
  background: ${({ theme }) => theme.colors.white};
  position: relative;
  flex: 1;
  overflow: auto;
`;

export const StyledActionMessage = styled.div``;

export const StyledActionMessageHead = styled('div', {
  shouldForwardProp: (prop) => prop !== 'readOnly',
})`
  display: flex;
  padding: 15px 20px;
  align-items: center;
  border-radius: ${({ active }) => (active ? '10px 10px 0 0' : '10px')};
  border: 1px solid ${({ theme }) => theme.colors.cardGridItemBorder};
  cursor: pointer;
  transition: background 0.3s ease;
  pointer-events: ${({ readOnly }) => (readOnly ? 'none' : 'auto')};

  ${({ opened }) =>
    opened &&
    `
      border-bottom: none;
      border-radius: 10px 10px 0 0;
    `};

  &:hover {
    background: ${({ theme }) => theme.colors.bgColorOptionTwo};
  }
`;

export const StyledActionMessageBody = styled.div`
  border-radius: 0 0 10px 10px;
  border: 1px solid ${({ theme }) => theme.colors.cardGridItemBorder};
  border-top: none;
`;
